export default __webpack_public_path__ + "static/media/bo.7b577652.png";